import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { CheckCircleIcon } from "@heroicons/react/24/outline";

const CTASection = () => {
  const images = [
    "/assets/gtplmobileui.png",
    "/assets/pay.png",
    "/assets/performance.png",
  ];

  const [index, setIndex] = useState(0);

  const nextSlide = () => setIndex((prev) => (prev + 1) % images.length);

  useEffect(() => {
    const interval = setInterval(nextSlide, 6000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section
      className="py-20 bg-white border-t border-gray-100"
      style={{ fontFamily: "Poppins, Roboto, sans-serif" }}
    >
      <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">

        {/* LEFT — CONTENT */}
        <motion.div
          initial={{ opacity: 0, x: -35 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.7 }}
          viewport={{ once: true }}
          className="space-y-6"
        >
              <h2 className="text-3xl md:text-3xl font-bold text-gray-900 leading-snug">
  Modern HR Workflows  
  <span
    className="block bg-gradient-to-r from-orange-400 via-amber-500 to-orange-600 
      text-transparent bg-clip-text drop-shadow-sm">
    Built for Real-World Teams
  </span>
</h2>




          <p
            className="text-gray-600 text-base md:text-lg leading-relaxed max-w-xl"
            style={{ fontFamily: "Roboto, sans-serif" }}
          >
            GTPL HRMS brings all HR operations into one clean interface — 
            attendance, payroll, helpdesk, shifts, approvals and more — designed 
            for everyday internal use.
          </p>

          {/* Feature List */}
          <div className="space-y-4">
            {[
              {
                head: "Unified dashboard experience",
                sub: "Everything employees need — attendance, salary slips, shifts, updates."
              },
              {
                head: "Smart approvals for team leaders",
                sub: "Managers review and approve HR requests instantly with a clean interface."
              },
              {
                head: "Fast and predictable helpdesk",
                sub: "Raise, track and resolve HR issues quickly with transparent SLAs."
              },
              {
                head: "Personalized workspace",
                sub: "Shortcuts and quick actions adapt to each employee’s role and department."
              },
              {
                head: "Smooth on all devices",
                sub: "Optimized layouts for mobile, tablets and desktops without UI breaks."
              },
            ].map((item, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 8 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: i * 0.12 }}
                className="flex items-start gap-3"
              >
                <CheckCircleIcon className="w-6 h-6 text-teal-600 flex-shrink-0" />
                <div>
                  <h4 className="text-gray-900 font-semibold text-base">{item.head}</h4>
                  <p
                    className="text-gray-600 text-sm mt-0.5"
                    style={{ fontFamily: "Roboto, sans-serif" }}
                  >
                    {item.sub}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>
        </motion.div>

        {/* RIGHT — IMAGE CAROUSEL */}
        <motion.div
          initial={{ opacity: 0, x: 35 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.7 }}
          viewport={{ once: true }}
          className="relative flex flex-col items-center w-full"
        >
          {/* Image */}
          <div className="relative w-full max-w-lg h-80 sm:h-96 md:h-[430px] overflow-hidden rounded-xl">
            <AnimatePresence mode="wait">
              <motion.img
                key={index}
                src={images[index]}
                alt="GTPL HRMS Screenshot"
                className="w-full h-full object-contain"
                initial={{ opacity: 0, x: 50 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: -50 }}
                transition={{ duration: 0.6 }}
              />
            </AnimatePresence>
          </div>

          {/* DOTS BELOW IMAGE */}
          <div className="flex mt-4 gap-2">
            {images.map((_, i) => (
              <button
                key={i}
                onClick={() => setIndex(i)}
                className={`h-3 w-3 rounded-full transition-all ${
                  index === i ? "bg-teal-600 w-6" : "bg-gray-300"
                }`}
              />
            ))}
          </div>
        </motion.div>

      </div>
    </section>
  );
};

export default CTASection;
